import React from 'react';
import MarketMovers from '../components/MarketMovers';
import { SEOMeta, getToolSEOMeta } from '../components/SEOMeta';

// Page wrapper for the Market Movers feature
// Provides heading + layout padding consistent with other pages.
const MarketMoversPage: React.FC = () => {
  const seoMeta = getToolSEOMeta('market-movers');

  return (
    <div className="py-8 sm:py-10">
      <SEOMeta
        title={seoMeta.title}
        description={seoMeta.description}
        keywords={seoMeta.keywords}
      />
      <div className="mx-auto max-w-screen-2xl px-4 sm:px-6 lg:px-8">
        <h1 className="text-2xl md:text-3xl font-semibold mb-6">Market Movers</h1>
        <MarketMovers />
        <p className="mt-6 text-[11px] md:text-xs text-theme-muted">Stock data provided for educational purposes only. Not financial advice.</p>
      </div>
    </div>
  );
};

export default MarketMoversPage;
